export enum ModalId {
  HeaderMenu
}

export const ModalPriorities = {};
